/* @ngInject */
function contextService (ConnectorWebService, CONSTANTS, Utils) {
  var oContextService = {}

  oContextService.getAllContextsByUserId = function (iUserId) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_CONTEXTS_BY_USER_COMPANY, [iUserId])
    return ConnectorWebService.get(sUrl)
  }

  oContextService.createContext = function (oContext) {
    return ConnectorWebService.post(CONSTANTS.URL_CONTEXTS, oContext)
  }

  oContextService.updateContext = function (oContext) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_CONTEXTS_BY_ID, [oContext.id])
    return ConnectorWebService.put(sUrl, oContext)
  }

  oContextService.deleteContext = function (iContextId) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_CONTEXTS_BY_ID, [iContextId])
    return ConnectorWebService.fnDelete(Utils.fnReplaceStringParams(sUrl))
  }

  return oContextService
}

export { contextService }
